const chromeStoreZaplifyId = 'nolanbablkmlhllilaloenjhaplnfhof';
const extensionId = import.meta?.env?.VITE_ZAPLIFY_CHROME_EXTENSION_ID || chromeStoreZaplifyId;
export const extensionLinkURL = `https://chrome.google.com/webstore/detail/andsend/${extensionId}`;
